import { Component, OnInit, OnDestroy, ViewChild, HostListener, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin, Subscription } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
const _ = require('lodash');
import * as $ from 'jquery';

import { CommonService } from './../../../../services/common/common.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { SeedCropLossService } from '../../../../services/seed/seed-crop-loss/seed-crop-loss.service';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { DashboardFilter } from './../../../../models/DashboardFilter';
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';

@Component({
  selector: 'app-seed-crop-loss-review',
  templateUrl: './seed-crop-loss-review.component.html',
  styleUrls: ['./seed-crop-loss-review.component.scss']
})
export class SeedCropLossReviewComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('failedPaginator', { read: MatPaginator }) failedPaginator: MatPaginator;

  subscription = new Subscription();
  masterConstants = MasterConstants;
  dashboardFilter: DashboardFilter;
  headerCompany = MasterConstants.US_COMPANYCODE;
  headerYear: any;
  requestHeaderId = 0;
  webOrderNumber: any;
  breadcrumbtext: string;
  soldToAccount: number;
  soldToDataLoading: any;
  soldToAccountList: any[];
  shipToAccountList: any[];
  shipToAccount: number;
  shipToAccountName: number;
  shipToDataLoading: any;
  readOnlyAccess = false;
  creditToList: any[];
  creditToAccount: number;
  creditToDataLoading: any;
  creditToAnotherLocation = false;
  growerList: any;
  growerGMK: number;
  growerLoading: any;
  requestedBy: string;
  requestOnBehalfList: any = [];
  emailAddress: string;
  isNotValid = false;
  productItemsDataSource: any;
  displayedColumns: string[] = ['product', 'lotNumber', 'eligibleUnits', 'unitsSoldToGrower', 'failedUnits', 'uom', 'problemDescription', 'approverNotes'];
  agreeToTermsAndConditions = false;
  isApproverUser = false;
  isViewRequest = false;
  isShowNonSubEmail = true;

  constructor(
    private router: Router,
    private commonService: CommonService,
    private loaderService: LoaderService,
    private seedCropLossService: SeedCropLossService,
    private localStorageService: LocalStorageService,
    private toastrService: ToastrService,
    private broadcastService: BroadcastService,
    private configService: ConfigService
  ) {
    this.dashboardFilter = new DashboardFilter();
  }

  ngOnInit(): void {
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
        if (!isActiveUser.isSubscriptionAccess) {
          this.isShowNonSubEmail = false;
        } else {
          this.isShowNonSubEmail = true;
        }
      }
    }
    this.subscription.add(this.seedCropLossService.reviewRequestId.subscribe(x => {
      if (x) {
        this.requestHeaderId = x;
        this.getOrderDetails();
      } else {
        this.router.navigate(['/']);
      }
    }));

    this.isApproverUser = this.seedCropLossService.isApproverUser;
    this.isViewRequest = this.seedCropLossService.isViewRequest;

    this.productItemsDataSource = new MatTableDataSource([]);
  }

  // Set page breadcrumb text
  setBreadcrumbText() {
    this.breadcrumbtext = `${this.isApproverUser ? 'Approve Request' : (this.isViewRequest ? 'View Request' : 'Review Request')} [${this.webOrderNumber}]`;
  }

  loadMasterData() {
    this.loaderService.setLoaderStatus(true);

    const forkJoinAPIs = [];
    forkJoinAPIs.push(this.seedCropLossService.getShipToAccountDataList());
    forkJoinAPIs.push(this.seedCropLossService.getAccountUser(0));
    this.subscription.add(forkJoin(forkJoinAPIs).subscribe((result: any[]) => {
      this.shipToAccountList = result[0];
      this.requestOnBehalfList = result[1];
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  getUserList(accountNumber) {
    this.subscription.add(this.seedCropLossService.getAccountUser(accountNumber).subscribe((result: any) => {
      if (result.length > 0) {
        this.requestOnBehalfList = result;
      }
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    this.seedCropLossService.isApproverUser = false;
    this.seedCropLossService.isViewRequest = false;
  }

  navigateToLandingPage() {
    this.router.navigate(['/crop-loss-landing']);
    this.commonService.currentTabIndex.next(1);
  }

  getGrowerListByAccount() {
    this.growerLoading = true;
    this.dashboardFilter.cropYear = this.headerYear;
    this.dashboardFilter.shipToAccount = this.shipToAccount;
    const growerFilters = { 'GrowerGLN': '', 'GrowerName': '' };
    this.subscription.add(this.seedCropLossService.getGrowerListByFilter(this.dashboardFilter, growerFilters).subscribe(result => {
      this.growerList = result;
      this.growerLoading = false;
      this.loaderService.setLoaderStatus(false);
    }, error => {
      this.growerLoading = false;
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // Get Order Details when opened in Edit/View Mode
  getOrderDetails() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.seedCropLossService.getEditDetail(this.requestHeaderId, 0).subscribe((result: any) => {
      const rowId = 0;
      if (result.failedProductList && result.failedProductList.length > 0) {
        result.failedProductList.forEach(x => {
          x.rowId = rowId + 1;
          x.isSelected = false;
          x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [] };
        });
      }

      this.webOrderNumber = result.webOrderNumber;
      this.shipToAccount = result.shipToAccount;

      this.getGrowerListByAccount();

      this.seedCropLossService.setSelectedAccountNo(this.shipToAccount);
      this.shipToAccountList = [result.shipToAccountDetail];
      this.soldToAccountList = [result.soldToAccountDetail];
      this.soldToAccount = Number(result.shipToAccountDetail.soldTo);

      this.creditToAccount = result.creditToAccountNumber;
      this.creditToAnotherLocation = result.creditToAccountNumber ? true : false;
      this.growerGMK = result.gmk;

      this.productItemsDataSource = new MatTableDataSource(result.failedProductList);
      this.productItemsDataSource.paginator = this.failedPaginator;
      this.productItemsDataSource.paginator.firstPage();

      this.setBreadcrumbText();

      if (this.creditToAccount) {
        const shipToAccountDetail = this.shipToAccountList.find(x => x.accountNumber == this.shipToAccount);
        this.subscription.add(this.seedCropLossService
          .getCreditToAccounts(shipToAccountDetail.accountNumber, shipToAccountDetail.parentNumber)
          .subscribe((result) => {
            this.creditToList = result;
            this.loaderService.setLoaderStatus(false);
          },
            error => this.loaderService.setLoaderStatus(false)));
      }

      this.requestedBy = result.requestedBy;
      // this.emailAddress = result.emailAddress;
      this.emailAddress = this.isShowNonSubEmail ? result.emailAddress : result.userEmail;

      const parentNumber = this.shipToAccountList.find(x => x.accountNumber === this.shipToAccount).parentNumber;
      this.getUserList(parentNumber);

      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  // set account table height
  setAccSummaryTableHeight() {
    const tableHeight = window.innerHeight - 50;
    $('.requestCOIOuter').css('height', tableHeight + 'px');
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccSummaryTableHeight();
  }

  editRequest(isApprover) {
    if (isApprover == 1) {
      this.router.navigate(['/crop-loss-request-entry', this.requestHeaderId, isApprover]);
    }
    else {
      this.router.navigate(['/crop-loss-request-entry', this.requestHeaderId, 0]);
    }
  }

  // Generate PDF
  generatedPdf() {
    this.seedCropLossService.generatePdf(this.requestHeaderId);
  }

  submitRequest() {
    this.loaderService.setLoaderStatus(true);
    const postData = {
      RequestHeaderId: this.requestHeaderId,
      AgreeToTermsAndConditions: this.agreeToTermsAndConditions
    };

    this.subscription.add(this.seedCropLossService.submitReviewRequest(postData).subscribe((result: any) => {
      if (result) {
        this.toastrService.success('Crop Loss Review request saved successfully.');

        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });

        this.loaderService.setLoaderStatus(false);

        this.navigateToLandingPage();
      } else {
        this.loaderService.setLoaderStatus(false);
        this.toastrService.error('Crop Loss Review request not submitted due to missing Configuration. Contact Winfield Customer Service at 1-855-494-6343 with questions.');
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error('Crop Loss Review request not saved in the system.');
    }));
  }

  hasDataChanged() {
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { hasCropLossDataChange: true });
  }

  approverAction(action) {
    this.loaderService.setLoaderStatus(true);
    const postData = {
      RequestHeaderId: this.requestHeaderId,
      RequestStatus: action,
      FailedProductList: this.productItemsDataSource.data.map(x => ({ detailsProductId: x.detailsProductId, approverNotes: x.approverNotes }))
    };

    this.subscription.add(this.seedCropLossService.approveReviewRequest(postData).subscribe((result: any) => {
      if (result) {
        this.toastrService.success('Crop Loss request saved successfully.');

        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });

        this.loaderService.setLoaderStatus(false);

        if (action == 'Save') {
          this.toastrService.success('Crop Loss request saved successfully.');
        } else {
          this.toastrService.success(`Crop Loss request ${action} successfully.`);
          this.navigateToLandingPage();
        }
      } else {
        this.loaderService.setLoaderStatus(false);
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error('Crop Loss request not saved in the system.');
    }));
  }

  public IsShowTreatment(element: any): boolean {
    if (element.treatment == 'JUT' && element.productLineId == '4J1') { return true; }
    return false;
  }
}
